import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface CityFieldProps {
  control: Control<FormProps>;
}

export function CityField({ control }: Readonly<CityFieldProps>) {
  return (
    <Controller
      name="city"
      control={control}
      rules={{ required: 'required' }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label="City"
          required
          fullWidth
          autoComplete="home city"
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
